// extracted by mini-css-extract-plugin
module.exports = {"footer":"ui_footer__nrnmu","copyright":"ui_copyright__mVWHy","social":"ui_social__UaOCX"};